import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col, Input, Button } from 'reactstrap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ESTADOS_OPORTUNIDAD, API, BASE_URL } from 'CONST';
import { patch, post } from 'helpers/requests';
import CheckModal from 'components/shared/CheckModal';
import WarningModal from 'components/UI/WarningModal';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';
import MotivosRechazoModal from './MotivosRechazoModal';

const AceptarBorradorSection = ({ fullData, id, estadosOportunidad, observaciones }) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [observacion, setObservacion] = useState('');
  const [observacionesEstado, setObservacionesEstado] = useState([]);
  const [editableSection, setEditableSection] = useState(false);
  const [motivoDesistimientoId, setMotivoDesistimientoId] = useState(null);
  const [mensajeCheckModal, setMensajeCheckModal] = useState('');
  const [mensajeWarningModal, setMensajeWarningModal] = useState('');

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [desistirModal, setDesistirModal] = useState(false);
  const [acceptModal, setAcceptModal] = useState(false);

  const editableStates = [ESTADOS_OPORTUNIDAD.borradorEnviado];

  useEffect(() => {
    if (observaciones) {
      setObservacionesEstado(
        observaciones.filter(
          (obs) => obs.estado.nemotecnico === ESTADOS_OPORTUNIDAD.borradorAceptado,
        ),
      );
    }
    if (fullData && fullData.estado && editableStates.includes(fullData.estado.nemotecnico)) {
      setEditableSection(true);
    }
  }, [observaciones, fullData]);

  const postObservacion = () => {
    if (observacion) {
      const body = {
        oportunidad_id: id,
        estado_id: estadosOportunidad.find(
          (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.borradorAceptado,
        ).id,
        observacion,
      };
      post(`${BASE_URL}${API.observaciones}/`, body).catch(() => {
        setMensajeWarningModal('Hubo un problema al guardar la observación');
        setShowErrorModal(true);
      });
    }
  };

  const avanzarOportunidad = (mensajeCheck, mensajeWarning, estadoFinal) => {
    setLoading(true);
    setMensajeCheckModal(mensajeCheck);
    setMensajeWarningModal(mensajeWarning);
    const body = {
      estado_id: estadosOportunidad.find((e) => e.nemotecnico === estadoFinal).id,
    };
    if (motivoDesistimientoId) {
      body.motivo_desistimiento_id = motivoDesistimientoId;
    }
    patch(`${BASE_URL}${API.oportunidades_garantia}/${id}/`, body)
      .then(() => {
        postObservacion();
        setShowUpdateModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setDesistirModal(false);
        setAcceptModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <FormGroup row>
        <Col sm={2}>
          <Label>Observaciones</Label>
        </Col>
        <Col>
          <Input
            id="observacion-info-inicial"
            type="textarea"
            value={
              !editableSection && observacionesEstado.length > 0
                ? observacionesEstado[0].observacion
                : observacion || ''
            }
            onChange={(event) => setObservacion(event.target.value)}
            rows="3"
            disabled={!editableSection}
          />
        </Col>
      </FormGroup>
      {observacionesEstado.slice(!editableSection).map((obs) => {
        return (
          <FormGroup row key={obs.id}>
            <Col sm={2} />
            <Col>
              <Input type="textarea" value={obs.observacion} rows="3" disabled />
            </Col>
          </FormGroup>
        );
      })}
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary warning-cancel no-bold"
            style={{ marginRight: 25 }}
            onClick={() => setDesistirModal(true)}
            disabled={desistirModal || acceptModal}
          >
            {loading && desistirModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Desistir de Contratar'
            )}
          </Button>
          <Button
            className="btn btn-secondary blue"
            onClick={() => setAcceptModal(true)}
            disabled={desistirModal || acceptModal}
          >
            {loading && acceptModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Aceptar Borrador'
            )}
          </Button>
        </div>
      )}
      <CheckModal
        isOpen={showUpdateModal}
        toggle={() => history.push('/guarantee/oportunities')}
        handleOk={() => history.push('/guarantee/oportunities')}
        okBtnText="OK"
        confirmMsg={mensajeCheckModal}
      />
      <MotivosRechazoModal
        openModal={desistirModal}
        toggleModal={() => setDesistirModal(!desistirModal)}
        observacion={observacion}
        setObservacion={setObservacion}
        avanzarOportunidad={avanzarOportunidad}
        motivoId={motivoDesistimientoId}
        setMotivoId={setMotivoDesistimientoId}
        loading={loading}
        esRechazo={false}
        fullData={fullData}
      />
      <AvanzarOportunidadConfirmationModal
        openModal={acceptModal}
        setOpenModal={setAcceptModal}
        avanzarOportunidad={() =>
          avanzarOportunidad(
            'Borrador aceptado exitosamente.',
            'No se pudo aceptar el borrador.',
            ESTADOS_OPORTUNIDAD.borradorAceptado,
          )
        }
        loading={loading}
        mensajeModal="¿Está seguro que desea ACEPTAR borrador para esta oportunidad?"
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleOk={() => setShowErrorModal(false)}
        okBtnText="Aceptar"
        confirmMsg={mensajeWarningModal}
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

AceptarBorradorSection.propTypes = {
  fullData: PropTypes.shape({
    estado: PropTypes.shape({
      nemotecnico: PropTypes.string,
    }),
  }),
  id: PropTypes.string,
  estadosOportunidad: PropTypes.arrayOf(PropTypes.shape({})),
  observaciones: PropTypes.arrayOf(PropTypes.shape({})),
};

AceptarBorradorSection.defaultProps = {
  fullData: null,
  id: null,
  estadosOportunidad: [],
  observaciones: [],
};

export default AceptarBorradorSection;
